import { FC, lazy, LazyExoticComponent, Suspense } from "react";
import { Navigate } from "react-router-dom";
import LoadingScreen from "components/LoadingScreen";
import Layout from "layouts/layout-v1/DashboardLayout";
import AuthGuard from "./page-sections/authentication/AuthGuard";
import ForgetPasswordVerifyCode from "./pages/authentication/forget-password-verify-code";

const Loadable = (Component: LazyExoticComponent<FC>) => (props: any) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

// authentication
const Login = Loadable(lazy(() => import("./pages/authentication/login")));
const Calendar = Loadable(lazy(() => import("./pages/calendar/index")));

const Register = Loadable(
    lazy(() => import("./pages/authentication/register"))
);

const VerifyCode = Loadable(
    lazy(() => import("./pages/authentication/verify-code"))
);

const NewPassword = Loadable(
    lazy(() => import("./pages/authentication/new-password"))
);

const SwitchToCabinet = Loadable(lazy(() => import("./pages/authentication/switch-to-cabinet")));

const ForgetPassword = Loadable(
    lazy(() => import("./pages/authentication/forget-password"))
);
const TwoStepVerify = Loadable(
    lazy(() => import("./pages/authentication/two-step-verification"))
);



const PlanReport = Loadable(
    lazy(() => import("./pages/plan-report/details"))
);
const PlanReportList = Loadable(
    lazy(() => import("./pages/plan-report/list"))
);
const PivotPlanReport = Loadable(
    lazy(() => import("./pages/pivot-plan-report"))
);
const WorkReport = Loadable(
    lazy(() => import("./pages/work-report/details"))
);
const WorkReportList = Loadable(
    lazy(() => import("./pages/work-report/list"))
);
const IncomeReport = Loadable(
    lazy(() => import("./pages/report-income/details"))
);
const IncomeReportList = Loadable(
    lazy(() => import("./pages/report-income/list"))
);



// dashboards
const CRM = Loadable(lazy(() => import("./pages/dashboards/crm")));
const Sales = Loadable(lazy(() => import("./pages/dashboards/sales")));
const SalesV2 = Loadable(lazy(() => import("./pages/dashboards/sales-v2")));
const SaaS = Loadable(lazy(() => import("./pages/dashboards/saas")));
const ProjectManagement = Loadable(
  lazy(() => import("./pages/dashboards/project-management"))
);
const ProjectManagementV2 = Loadable(
  lazy(() => import("./pages/dashboards/project-management-v2"))
);
const JobManagement = Loadable(
  lazy(() => import("./pages/dashboards/job-management"))
);
const LearningManagement = Loadable(
  lazy(() => import("./pages/dashboards/learning-management"))
);

// account
const Account = Loadable(lazy(() => import("./pages/accounts/account")));
const AccountV2 = Loadable(lazy(() => import("./pages/accounts/account-v2")));

// user and contact
const AddUser = Loadable(lazy(() => import("./pages/user-list/add-new-user")));
const UserList = Loadable(
  lazy(() => import("./pages/user-list/user-list-view"))
);
const UserListV2 = Loadable(
  lazy(() => import("./pages/user-list/user-list-view-v2"))
);
const UserGrid = Loadable(
  lazy(() => import("./pages/user-list/user-grid-view"))
);
const UserGridV2 = Loadable(
  lazy(() => import("./pages/user-list/user-grid-view-v2"))
);
const ContactList = Loadable(
  lazy(() => import("./pages/contact-list/contact-list-view"))
);
const ContactGrid = Loadable(
  lazy(() => import("./pages/contact-list/contact-grid-view"))
);

// profile
const Profile = Loadable(lazy(() => import("./pages/profiles/profile")));
const ProfileV2 = Loadable(lazy(() => import("./pages/profiles/profile-v2")));

// profile
/*
const DataTableV2 = Loadable(
  lazy(() => import("./pages/data-table/data-table-v2"))
);
 */

// invoice
const InvoiceList = Loadable(lazy(() => import("./pages/invoice/list")));
const InvoiceList2 = Loadable(
  lazy(() => import("./pages/invoice/invoice-list-v2"))
);
const CreateInvoice = Loadable(lazy(() => import("./pages/invoice/create")));
const CreateInvoice2 = Loadable(
  lazy(() => import("./pages/invoice/add-invoice-v2"))
);
const InvoiceDetails = Loadable(lazy(() => import("./pages/invoice/details")));
const InvoiceDetails2 = Loadable(
  lazy(() => import("./pages/invoice/invoice-details-v2"))
);

// eCommerce
const Shop = Loadable(lazy(() => import("./pages/ecommerce/shop")));
const ShopV2 = Loadable(lazy(() => import("./pages/ecommerce/shop-v2")));
const Cart = Loadable(lazy(() => import("./pages/ecommerce/Cart")));
const Payment = Loadable(lazy(() => import("./pages/ecommerce/payment")));
const Checkout = Loadable(lazy(() => import("./pages/ecommerce/checkout")));
const CheckoutV2 = Loadable(
  lazy(() => import("./pages/ecommerce/checkout-v2"))
);
const ProductDetails = Loadable(
  lazy(() => import("./pages/ecommerce/product-details"))
);
const BillingAddress = Loadable(
  lazy(() => import("./pages/ecommerce/billing-address"))
);
const PaymentComplete = Loadable(
  lazy(() => import("./pages/ecommerce/payment-complete"))
);
const PaymentCompleteV2 = Loadable(
  lazy(() => import("./pages/ecommerce/payment-complete-v2"))
);

// pricing
const Pricing = Loadable(lazy(() => import("./pages/pricing")));

// pricing
const TodoList = Loadable(lazy(() => import("./pages/todo-list")));

// offer
const OfferList = Loadable(lazy(() => import("./pages/offer/list")));
const OfferDetails = Loadable(lazy(() => import("./pages/offer/details")));

// offer
const ContractList = Loadable(lazy(() => import("./pages/contracts/list")));
const ContractDetails = Loadable(lazy(() => import("./pages/contracts/details")));

//lesson
const LessonList = Loadable(lazy(() => import("./pages/lesson/list")));
const LessonDetails = Loadable(lazy(() => import("./pages/lesson/details")));

const DocsList = Loadable(lazy(() => import("./pages/docs/list")));

//schedules
const Schedule = Loadable(lazy(() => import("./pages/schedule")));

//ask question
const AskQuestion = Loadable(lazy(() => import("./pages/ask-question")));


// admin ecommerce
const ProductList = Loadable(
  lazy(() => import("./pages/admin-ecommerce/product-list"))
);
const ProductGrid = Loadable(
  lazy(() => import("./pages/admin-ecommerce/product-grid"))
);
const CreateProduct = Loadable(
  lazy(() => import("./pages/admin-ecommerce/create-product"))
);
const CustomerManagement = Loadable(
  lazy(() => import("./pages/admin-ecommerce/customer-management"))
);
const OrderManagement = Loadable(
  lazy(() => import("./pages/admin-ecommerce/order-management"))
);
const ProductManagement = Loadable(
  lazy(() => import("./pages/admin-ecommerce/product-management"))
);

// chat
/*
const ChatV1 = Loadable(lazy(() => import("./pages/chats/chat-v1")));
const ChatV2 = Loadable(lazy(() => import("./pages/chats/chat-v2")));
 */

// user projects
const ProjectDetails = Loadable(
  lazy(() => import("./pages/projects/project-details"))
);
const ProjectV1 = Loadable(lazy(() => import("./pages/projects/project-v1")));
const ProjectV2 = Loadable(lazy(() => import("./pages/projects/project-v2")));
const TeamMember = Loadable(lazy(() => import("./pages/projects/team-member")));
const ProjectV3 = Loadable(lazy(() => import("./pages/projects/project-v3")));

// Landing page
const AboutPage = Loadable(lazy(() => import("./pages/about")));
const ContactPage = Loadable(lazy(() => import("./pages/contact")));
const PricingPage = Loadable(lazy(() => import("./pages/pricing-v2")));
const PrivacyPage = Loadable(lazy(() => import("./pages/privacy")));

// 404/Error page
const Error = Loadable(lazy(() => import("./pages/404")));


const routes = () => {
  return [
    ...authRoutes,
    {
      path: "dashboard",
      element: <AuthGuard><Layout /></AuthGuard>,
      children: dashboardRoutes,
    },
    {
      path: "*",
      element: <Error />,
    },
  ];
};

const authRoutes = [
  { path: "/", element: <Navigate to="/dashboard" /> },
  { path: "login", element: <Login /> },
  { path: "calendar", element: <Calendar /> },
  { path: "register", element: <Register /> },
  { path: "verify-code", element: <VerifyCode /> },
  { path: "forget-password-verify-code", element: <ForgetPasswordVerifyCode /> },
  { path: "new-password", element: <NewPassword /> },
  { path: "forget-password", element: <ForgetPassword /> },
  { path: "two-step-verification", element: <TwoStepVerify /> },
  { path: "switch-to-cabinet", element: <SwitchToCabinet /> },
];

const dashboardRoutes = [
  { path: "", element: <LearningManagement /> },
  { path: "job-management", element: <JobManagement /> },
  { path: "sales", element: <Sales /> },
  { path: "sales-v2", element: <SalesV2 /> },
  { path: "crm", element: <CRM /> },
  { path: "saas", element: <SaaS /> },
  { path: "sub-child-v1", element: <SalesV2 /> },
  { path: "sub-child-v2", element: <ProjectManagement /> },
  { path: "sub-child-v3", element: <ProjectManagementV2 /> },
  { path: "project-management", element: <ProjectManagement /> },
  { path: "project-management-v2", element: <ProjectManagementV2 /> },

  { path: "account", element: <Account /> },
  { path: "account-v2", element: <AccountV2 /> },

  { path: "profile", element: <Profile /> },
  { path: "profile-v2", element: <ProfileV2 /> },



  { path: "add-user", element: <AddUser /> },
  { path: "user-list", element: <UserList /> },
  { path: "user-list-v2", element: <UserListV2 /> },
  { path: "user-grid", element: <UserGrid /> },
  { path: "user-grid-v2", element: <UserGridV2 /> },
  { path: "contact-list", element: <ContactList /> },
  { path: "contact-grid", element: <ContactGrid /> },

  { path: "offer-list", element: <OfferList /> },
  { path: "offer-details/:id", element: <OfferDetails /> },

  { path: "contract-list", element: <ContractList /> },
  { path: "contract-details/:id", element: <ContractDetails /> },

  { path: "work-report", element: <WorkReportList /> },
  { path: "work-report/:id", element: <WorkReport /> },

  { path: "income-report", element: <IncomeReportList /> },
  { path: "income-report/:id", element: <IncomeReport /> },

  { path: "plan-report/:id", element: <PlanReport /> },
  { path: "plan-report", element: <PlanReportList /> },

  { path: "pivot-plan-report", element: <PivotPlanReport /> },

  { path: "docs", element: <DocsList /> },

  { path: "lesson-list", element: <LessonList /> },
  { path: "lesson-details/:id", element: <LessonDetails /> },
  { path: "schedule", element: <Schedule /> },
  { path: "ask-question", element: <AskQuestion /> },

  { path: "invoice-list", element: <InvoiceList /> },
  { path: "invoice-list-v2", element: <InvoiceList2 /> },
  { path: "create-invoice", element: <CreateInvoice /> },
  { path: "create-invoice-v2", element: <CreateInvoice2 /> },
  { path: "invoice-details", element: <InvoiceDetails /> },
  { path: "invoice-details-v2", element: <InvoiceDetails2 /> },

  { path: "project-v1", element: <ProjectV1 /> },
  { path: "project-v2", element: <ProjectV2 /> },
  { path: "project-v3", element: <ProjectV3 /> },
  { path: "team-member", element: <TeamMember /> },
  { path: "project-details", element: <ProjectDetails /> },

  { path: "shop", element: <Shop /> },
  { path: "shop-v2", element: <ShopV2 /> },
  { path: "cart", element: <Cart /> },
  { path: "payment", element: <Payment /> },
  { path: "checkout", element: <Checkout /> },
  { path: "checkout-v2", element: <CheckoutV2 /> },
  { path: "product-details", element: <ProductDetails /> },
  { path: "billing-address", element: <BillingAddress /> },
  { path: "payment-complete", element: <PaymentComplete /> },
  { path: "payment-complete-v2", element: <PaymentCompleteV2 /> },

  { path: "product-list", element: <ProductList /> },
  { path: "product-grid", element: <ProductGrid /> },
  { path: "create-product", element: <CreateProduct /> },
  { path: "customer-management", element: <CustomerManagement /> },
  { path: "order-management", element: <OrderManagement /> },
  { path: "product-management", element: <ProductManagement /> },

    /*
  { path: "data-table-v2", element: <DataTableV2 /> },
  { path: "chat-v1", element: <ChatV1 /> },
  { path: "chat-v2", element: <ChatV2 /> },
     */
    /*
  { path: "pricing", element: <Pricing /> },
  { path: "todo-list", element: <TodoList /> },

    */
    /*
  { path: "about", element: <AboutPage /> },
  { path: "contact", element: <ContactPage /> },
  { path: "pricing", element: <PricingPage /> },
  { path: "privacy", element: <PrivacyPage /> },

     */
];

export default routes;
